import * as React from "react";
import { ChatBubbleIcon } from "@radix-ui/react-icons";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { useCommonDialogs } from "../CommonDialogsProvider.tsx";
import { CardIconButton } from "./ItemActions.tsx";

interface Props {
  itemId: Id<"items">;
}

export const ItemChatActionButton: React.FC<Props> = ({ itemId }) => {
  const dialogs = useCommonDialogs();
  return (
    <CardIconButton label="Chat about it" onClick={() => dialogs?.openItemChat({ itemId })}>
      <ChatBubbleIcon />
    </CardIconButton>
  );
};
